module.exports = __webpack_public_path__ + "static/media/matnrrd_2-961w.6ddb831b.png";